import { memo } from 'react';
import { Label, Select } from 'semantic-ui-react';
import { useRowBoundingBox } from '../../../../../../stores/boundingBoxesStore';
import { ImportDescriptorDataTypeType, ImportDescriptorIdType } from '../../../../../../types';
import { getOptions } from '../../../../../../utils/tableExtraction';
import { ImageHighlighterWrapper } from '../../../../../imageHighlighter/imageHighlighter';
import {
    useImportTableStoreDescriptorsEditMode,
    useImportTableStoreDescriptor,
    useImportTableStoreDescriptorActions,
} from '../../../../context/importTableContext';
import { TYPES } from './constants';
import { getSelectTypeStyling } from './utils';
import { IMPORT_DESCRIPTOR_TYPE } from '../../../../../../constants/generalConstants';

type DescriptorTypeCellPropsType = {
    descriptorId: ImportDescriptorIdType;
};
const DescriptorTypeCell = memo(function DescriptorTypeCell({ descriptorId }: DescriptorTypeCellPropsType) {
    const descriptor = useImportTableStoreDescriptor(descriptorId);
    const editing = useImportTableStoreDescriptorsEditMode();
    const { updateDescriptorType, enableDescriptorsEditMode } = useImportTableStoreDescriptorActions();

    const rowBoundingBox = useRowBoundingBox(descriptor.id);
    return (
        <td onDoubleClick={enableDescriptorsEditMode} className={editing ? 'cell--editing' : ''}>
            <ImageHighlighterWrapper boundingBox={rowBoundingBox}>
                {editing && descriptor.newDescriptor ? (
                    <DescriptorTypeEdit
                        disabled={!editing}
                        value={descriptor.dataType}
                        handleChange={(data) =>
                            updateDescriptorType(descriptor.id, data as ImportDescriptorDataTypeType)
                        }
                    />
                ) : (
                    <ReadDescriptorType dataType={descriptor.dataType} />
                )}
            </ImageHighlighterWrapper>
        </td>
    );
});

export default DescriptorTypeCell;

type DescriptorTypeEditPropsType = {
    disabled: boolean;
    value: ImportDescriptorDataTypeType;
    handleChange: (data: string) => void;
};
function DescriptorTypeEdit({ disabled, value, handleChange }: DescriptorTypeEditPropsType) {
    const { classes } = getSelectTypeStyling(value);
    return (
        <Select
            className={classes}
            data-data-type={value}
            disabled={disabled}
            placeholder="Type"
            value={value}
            options={getOptions(TYPES)}
            onChange={(__, data) => handleChange(data.value as string)}
        />
    );
}

type ReadDescriptorTypePropsType = {
    dataType: ImportDescriptorDataTypeType;
};

function ReadDescriptorType({ dataType }: ReadDescriptorTypePropsType) {
    const color = dataType === IMPORT_DESCRIPTOR_TYPE.ANY ? 'yellow' : 'grey';
    return (
        <Label color={color} className="import-table__label" size="mini">
            {dataType}
        </Label>
    );
}
